import { formatPhone, getInitials } from 'utils/helpers';
import Option from './Option';

const ContactList = ({ title, personType, contacts = [] }) => {
  if (!contacts.length) return null;

  return (
    <div>
      <p className="sticky top-0 z-10 border-b border-gray-100 bg-secondary-50 px-4 py-2.5 text-[11px] font-bold uppercase tracking-wider text-secondary-500 sm:px-5">
        {title} <span className="ml-1.5 text-secondary-400">{contacts.length}</span>
      </p>

      {contacts.map(({ id, attributes }) => {
        const { first_name, last_name, relationship, phone, mobile_phone } = attributes;
        const name = `${first_name} ${last_name}`;
        const number = phone || mobile_phone;

        return (
          <Option
            key={`${personType}-${id}`}
            value={id}
            personType={personType}
            avatar={
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-sm font-bold text-secondary-500">
                {getInitials(name)}
              </span>
            }
            title={name}
            subtitle={[relationship, number && formatPhone(number)].filter(Boolean).join(' · ')}
          />
        );
      })}
    </div>
  );
};

export default ContactList;
